let loaded = false;
let s: HTMLScriptElement | null = null;


export const WxAppid = import.meta.env.VITE_WX_APPID || 'wx7b6e0021eecaf83b';

let jump = 0
export const authorizeWxCode = (url: string, params = '') => {
    //localStorage.setItem('JUMPS', params);
    //console.log(url);
    const time = new Date().getTime()
    if (time - jump > 1000) {
        jump = new Date().getTime();
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WxAppid}&redirect_uri=${encodeURI(
            url
        )}&response_type=code&scope=snsapi_base&state=${params}#wechat_redirect`;
    }
};

export const getJumpParams = () => {
    const data = localStorage.getItem('JUMPS');
    //localStorage.removeItem('JUMPS');
    return data;
};

// export const IWeChart =()=> {
// 	miniProgram: wx.miniProgramMethods;
//
// 	chooseWXPay(params: wx.IchooseWXPay): void;
//
// 	updateAppMessageShareData(params:wx.IupdateAppMessageShareData):void;
// 	updateTimelineShareData(params:wx.IupdateTimelineShareData):void;
//
// 	ready(f:() => any):void
//
// 	config: (conf: {
// 		debug?: boolean; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
// 		appId: string; // 必填，公众号的唯一标识
// 		timestamp: number; // 必填，生成签名的时间戳
// 		nonceStr: string; // 必填，生成签名的随机串
// 		signature: string; // 必填，签名，见附录1
// 		jsApiList: wx.jsApiList; // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
// 		openTagList: wx.openTagList;
// 	}) => void;
// };

/*
declare global {
    interface Window {
        wx: IWeChart;
    }
}

export const initWxSdk = (): Promise<IWeChart> => {
    return new Promise((resolve) => {
        if (loaded) {
            s = null;
            resolve(window.wx);
        } else {
            if (!s) {
                s = document.createElement('script');
                s.addEventListener(
                    'load',
                    () => {
                        loaded = true;
                        resolve(window.wx);
                    },
                    false
                );
                s.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
                document.body.append(s);
            } else {
                s.addEventListener(
                    'load',
                    () => {
                        loaded = true;
                        resolve(window.wx);
                    },
                    false
                );
            }
        }
    });
};*/
